import FeeTax from './quoteRefundModels/feeTax';

export class PenaltyInfoUIModel {
  constructor({
    changeFeeAmount = {
      amount: '',
      currency: '',
    },
    otherFeeAmount = {
      amount: '',
      currency: '',
    },
    feeTaxes = [],
    totalRefundAmountAfterPenalty = {
      amount: '',
      currency: '',
    },
    penaltyApplies = false,
  }) {
    this.changeFeeAmount = changeFeeAmount;
    this.otherFeeAmount = otherFeeAmount;
    this.feeTaxes = feeTaxes.map(feeTax => new FeeTax(feeTax));
    this.totalRefundAmountAfterPenalty = totalRefundAmountAfterPenalty;
    this.penaltyApplies = penaltyApplies;
  }
}